/* Keep same-page finder navigation usable when the mobile drawer is open. */
if (!window.scrFinderNavReady) {
  window.scrFinderNavReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-scr-finder-nav]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.href);
    const target = document.getElementById('scr-finder');
    if (!target || url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#scr-finder') return;
    event.preventDefault();
    const drawer = link.closest('header-drawer');
    const summary = drawer?.querySelector('details[open] > summary');
    if (summary) summary.click();
    history.replaceState(null, '', location.pathname + location.search + '#scr-finder');
    requestAnimationFrame(() => {
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:'instant',block:'start'});
    });
  });
}
